var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',{staticClass:"image",style:(_vm.maxHeight)},[_c('img',{attrs:{"src":_vm.content}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }